import { Component } from "react";
import { graphql } from "gatsby";
import { extract } from "@parksandresorts/core";
import styles from "./accommodation-block.module.less";

export default class AccommodationBlock extends Component {
  constructor(props) {
    super(props);
    this.title = extract(props, "title");
    this.preamble = extract(props, "preamble.preamble");
    this.description = extract(props, "description.childMarkdownRemark.html");
  }

  render() {
    return (
      <section
        className={[`block block--with-utility`, styles.restaurantBlock].join(" ")}
        data-contentful-id={this.props.contentful_id}
      >
        <div className={["block--max-width block--floating", styles.outerWrapper].join(" ")}>
          <div className={["block--padded", styles.contentWrapper].join(" ")}>
            {this.title && <h2 className={["h1", styles.title].join(" ")}>{this.title}</h2>}
            {this.preamble && <div className={["preamble"].join(" ")}>{this.preamble}</div>}
            {this.description && (
              <div className={styles.description} dangerouslySetInnerHTML={{ __html: this.description }} />
            )}
          </div>
        </div>
      </section>
    );
  }
}

export const fragmentAccommodationBlock = graphql`
  fragment AccommodationBlock on ContentfulAccommodationBlock {
    contentful_id
    title
    preamble {
      preamble
    }
    description {
      childMarkdownRemark {
        html
      }
    }
    imageInList {
      gatsbyImageData(placeholder: NONE, quality: 100)
    }
    label
    pageLink {
      slug
    }
    priceExample
    numberOfPeople
    size
    numberOfNights
  }
`;
